enum ActionTypes {
	request = 'MedicinalBrandsAnalytics.VirtualBrand.Reimbursement.request',
	receive = 'MedicinalBrandsAnalytics.VirtualBrand.Reimbursement.receive',
	pruneAll = 'MedicinalBrandsAnalytics.VirtualBrand.Reimbursement.pruneAll',
}

export default ActionTypes;
